import { useFormikContext } from 'formik';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import bt from '../bootstrap.module.css';
import FormElementWrapper from '../components/FormElementWrapper';
import InlineEdit from '../components/InlineEdit';
import useGetFormGeneratorItemError from '../hooks/useGetFormGeneratorItemError';

const MultiLineInput = props => {
  const { data, onChange, isBuilder, disabled, value, readOnly } = props;
  const { requiredError } = useGetFormGeneratorItemError(data.id);
  const textareaRef = useRef();
  const [isEditing, setIsEditing] = useState(false);
  const { setFieldValue, values } = useFormikContext();
  const index = values?.data?.findIndex(({ id }) => id === props.data.id);

  const handleChange = useCallback(
    e => {
      onChange(data.type, data.id, e.target.value);
    },
    [onChange, data.type, data.id],
  );

  const handleLabelChange = e => {
    const { name, value } = e.target;
    setFieldValue(`data[${index}].${name}`, value);
  };

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 4 + 'px';
    }
  }, [value]);

  return (
    <FormElementWrapper {...props} onClick={!readOnly ? () => setIsEditing(true) : undefined}>
      <div className={bt['form-group']}>
        <div className="font-semibold">
          <InlineEdit
            value={data.label}
            onChange={handleLabelChange}
            fieldName="label"
            isEditing={isEditing}
            onSetIsEditing={setIsEditing}
            readOnly={readOnly}
          />
        </div>
        <textarea
          ref={textareaRef}
          disabled={isBuilder || disabled}
          placeholder={data.placeholder}
          className="block w-full border py-0.5 px-1"
          onChange={handleChange}
          value={value}
          style={{ borderRadius: 2 }}
        />
        {requiredError && <div style={{ color: 'red', marginTop: 4 }}>This field is required</div>}
      </div>
    </FormElementWrapper>
  );
};

export default MultiLineInput;
